export class ResponseError extends Error {
  response: Response;
  body?: ResponseErrorBody;

  constructor(message: string, response: Response, body?: ResponseErrorBody) {
    super(message);
    this.response = response;
    this.body = body;
  }

  get correlationId() {
    return (
      this.response.headers.get("X-Correlation-Id")?.slice(-8) || undefined
    );
  }
}

export interface ResponseErrorBody {
  message: string;
  error: string;
}
